import { axios_nomination } from '@/plugins/axios';
import configuration from '@/configurations';

class ScoringRepository {

  /**
   * @returns {Promise}
   */
  async getScores(params) {

    const {
      organization_id,
      ...other_params
    } = params;

    const result = await axios_nomination
      .get(
        `${configuration.api_host}/v1/scoring/organizations/${organization_id}/scores`,
        {
          params: other_params,
        }
      );

    return result.data;
  }
}

const scoring_repository = new ScoringRepository();

export {
  scoring_repository,
};
